<template>
	<!-- 我的考试 -->
	<div class="uni-exam-wrap participateTestOwn">
		<div class="uni-exam-pay">
			<div class="continer">
				<Title text="考试中心"></Title>
				<!-- filter-box -->
				<div class="box filter-box">
					<ul class="filter-list">
						<li class="item">
							<span class="tit">考试方式</span>
							<div>
								<el-radio v-for="(item, index) in course" :key="index" class="radio" v-model="courseModel" :label="item.val" @change="getData">
									{{ item.name }}
								</el-radio>
							</div>
						</li>
						<!-- <li class="item">
							<span class="tit">考试状态</span>
							<div>
								<el-radio v-for="(item, index) in progress" :key="index" class="radio" v-model="progressModel" :label="item.val" @change="getData">
									{{ item.name }}
								</el-radio>
							</div>
						</li> -->
					</ul>
				</div>

				<div class="elTable">
					<!-- table -->
					<el-table slot="list" :data="dataList" headerRowClassName="uni-primary-table-header" stripe border>
						<el-table-column prop="title" align="center" label="考试名称"></el-table-column>
						<el-table-column prop="exam_time" align="center" label="考试时间" width="350">
						</el-table-column>
						<!-- <el-table-column prop="course_title" align="center" label="课程名称"></el-table-column> -->
						<el-table-column prop="exam_type" align="center" label="考试类型">
							<template slot-scope="scope">
								{{ course[scope.row.exam_type].name }}
							</template>
						</el-table-column>
						<el-table-column prop="status_title" align="center" label="状态">
							<!-- <template slot-scope="scope">
								<span>{{ progressMap[(scope.row.exam_status)-1] }}</span>
							</template> -->
						</el-table-column>
						<!-- <el-table-column prop="score" align="center" label="成绩">
							<template slot-scope="{ row }">
								{{ row.exam_status == 7 ? row.score : '--' }}
							</template>
						</el-table-column> -->
						<!-- <el-table-column prop="created_at" align="center" label="考试要求">
							<template v-slot="scoped">
								<el-button type="text" @click="handleExamine(scoped.row)" v-if="scoped.row.exam_type === 1">[查看]</el-button>
								<span v-else>无</span>
							</template>
						</el-table-column> -->
						<el-table-column align="center" width="200" label="操作">
							<template slot-scope="scope">
								<!-- <el-button style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button> -->
								<!-- 考试未开始 -->
								<!-- 判断 状态为待考试 状态是否为 线上考试 当前时间是否在考试时间内 -->
								<!-- <el-button style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button> -->
								<el-button size="small" style="font-size: 12px" type="text" @click="examChurch(scope.row)">考试信息</el-button>
                <el-button v-if="scope.row.is_sign_in == 1" size="small" style="font-size: 12px" type="text" @click="examSignIn(scope.row)">查看考签</el-button>
<!--								<div v-if="is_take_exam(scope.row) || scope.row.is_sign_in == 1">-->
<!--									&lt;!&ndash; <span>{{ getEndTime[scope.$index] | formatTime }}</span> &ndash;&gt;-->
<!--									&lt;!&ndash; <el-button v-if="is_take_exam(scope.row)" size="small" style="font-size: 12px" type="primary" @click="startExam(scope.row)">开始考试</el-button> &ndash;&gt;-->
<!--									<el-button v-if="scope.row.is_sign_in == 1" size="small" style="font-size: 12px" type="text" @click="examSignIn(scope.row)">查看考签</el-button>-->
<!--								</div>-->
								<!-- 考试截止 -->
								<!-- <el-button style="font-size: 12px" type="primary" v-else-if="scope.row.exam_status == 5" @click="examEnd(scope.row)">查看成绩</el-button> -->
								<!-- <span v-else>--</span> -->
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!-- 考试要求
			<el-dialog :visible.sync="dialogVisible" width="30%">
				<div class="dialogContent">
					<div class="dialogContent-title">
						<h3>考试要求</h3>
						<div></div>
					</div>
					<div class="dialogContent-content">
						<div v-for="(value, index) in examRegist" :key="index">
							<span>{{ index + 1 }}</span>
							<em>{{ value }}</em>
						</div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="dialogVisible = false">知道了</el-button></span>
			</el-dialog> -->
			<!-- <el-dialog width="800px" title="地址" :visible.sync="examInfoVisible">
				<div class="dialog" style="padding: 0 0 10%">
					<el-table :data="[userInfo]" style="width: 100%">
						<el-table-column v-if="_ENTRANCETYPE === 'own'" prop="exam_point_address" label="考点"></el-table-column>
						<el-table-column prop="exam_room_teacher_sn" label="考室">
							<template slot-scope="{ row }">
								第{{ row.exam_room_teacher_sn }}考室
							</template>
						</el-table-column>
						<el-table-column prop="exam_room_title" label="教室"></el-table-column>
						<el-table-column prop="exam_room_seat_number" label="座位序号"></el-table-column>
						<el-table-column prop="exam_room_teacher_title" label="监考老师"></el-table-column>
						<el-table-column prop="exam_room_address" label="详细地址"></el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="examInfoVisible = false">知道了</el-button></span>
			</el-dialog> -->
		</div>
	</div>
</template>

<script>
import { getMyExamsOwn, getExamsNotice, resetSign } from '@/api/exam';
import { mapState } from 'vuex';
export default {
	name: 'participateTestOwn',
	data() {
		return {
			courseModel: 0,
			course: [
				{ name: '全部', val: 0 },
				{ name: '线上考试', val: 1 },
				{ name: '线下考试', val: 2 },
				{ name: '模拟考试', val: 3 }
			],
			// progressModel: 0,
			dataList: [],
			// examInfoVisible: false,
			examRegist: [],
			timer: [],
			getEndTime: [],
			userInfo: [],
			// progress: [
			// 	{ name: '全部', val: 0 },
			// 	// { name: "报名待审核", val: 1 },
			// 	// { name: "缴费审核失败", val: 2 },
			// 	{ name: '待考试', val: 2 },
			// 	{ name: '阅卷中', val: 3 },
			// 	{ name: '缺考', val: 4 },
			// 	{ name: '考试完成', val: 5 },
			// ],
			// progressMap: ['未缴费', '待考试', '阅卷中', '缺考', '考试完成', '考试中', '阅卷完成'],
			// dialogVisible: false,
		};
	},
	watch: {
		// isFace(val) {
		// 	if (!val) this.$refs['face'].sportsCamera();
		// }
	},
	computed: {
		...mapState('common', {
			studentMajor: state => state.studentMajor
		}),
		...mapState('permission', {
			_ENTRANCETYPE: state => state._ENTRANCETYPE
		})

	},
	filters: {
		// formatTime(leftTime) {
		// 	if (leftTime > 0) {
		// 		let d, h, m, s;
		// 		d = Math.floor(leftTime / (1000 * 60 * 60 * 24));
		// 		h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
		// 		m = Math.floor((leftTime / 1000 / 60) % 60);
		// 		s = Math.floor((leftTime / 1000) % 60);
		// 		let getTimes = `${d > 0 ? d + '天' : ''}${h > 9 ? h : '0' + h}时${m > 9 ? m : '0' + m}分 ${s > 9 ? s : '0' + s}秒`;
		// 		return getTimes;
		// 	}
		// }
	},

	mounted() {
		this.getData();
	},
	beforeDestroy() {
		// 清除定时器
		if (this.timer.length > 0) {
			this.timer.forEach(timer => {
				if (timer) {
					clearInterval(timer);
				}
			});
		}
	},
	methods: {
		// 点击 查看考试
		examChurch(row){
			this.$router.push({
				name: 'examChurchOwn',
				query: {
					id: row.id
				}
			});
		},
		// 点击 查看考签
		examSignIn(row){
			this.$router.push({
				name: 'examSignInOwn',
				query: {
					id: row.id,
				},
			})
		},
		// exam_address(row) {
		// 	this.userInfo = row;
		// 	this.examInfoVisible = true;
		// },
		//判断当前时间是否在时区里
		isDuringDate(beginDateStr, endDateStr) {
			var curDate = new Date().getTime(),
				beginDate = new Date(beginDateStr.replace(/-/g,"/")).getTime(),
				endDate = new Date(endDateStr.replace(/-/g,"/")).getTime();
			if (curDate >= beginDate && curDate <= endDate) {
				return true;
			}
			return false;
		},
		// 我的考试
		async getData() {
			let params = {
				exam_type: this.courseModel,
			};
			const { result } = await getMyExamsOwn(params);

			if (result) {
				this.dataList = result.list || result;
				// console.log(this.dataList);
				// // 设置考试倒计时定时器
				// this.getTimer(result.list);
			}
		},
		// 开始考试
		startExam(data) {
			// console.log(data);
			// // 屏蔽人脸摄像头验证
			this.$router.push({
				name: 'examDetailsOwn',
				query: {
					examId: data.id
				}
			});
		},
		//考试状态 判断是否 可以考试
		is_take_exam(row){
			if((row.exam_status == 2 || row.exam_status == 6) && (row.exam_type == 1 || row.exam_type == 3) && row.is_open_book == 0 && this.isDuringDate(row.exam_hall_start_time,row.exam_hall_end_time)){
				return true;
			}
			return false;
		},

		// // 考试要求
		// async handleExamine(row) {
		// 	let arr = [
		// 		'为保证考试的公平公正，在考试开始前会进行人脸识别，请保证摄像头打开，场所光线充足;',
		// 		'若考试过程出现断电断网等突发情况，第一时间联系老师;',
		// 		'部分题目需要上传图片，请准备一部智能手机',
		// 		'首次参加考试前，必须参加一次模拟考试。'
		// 	];

		// 	if (row.exam) {
		// 		const params = {
		// 			exam_line_id: row.exam.id,
		// 			exam_type: row.exam_type
		// 		};
		// 		const { result } = await getExamsNotice(params);

		// 		if (result) {
		// 			//  判断提前交卷的时间
		// 			if (result.is_advance) {
		// 				arr.push(`本场考试限制提前${result.advance}分钟交卷；`);
		// 			}
		// 			// // 判断人脸识别的频率
		// 			if (result.is_face_rate) {
		// 				arr.push('本场考试过程中，会进行人脸识别，考试过程中面部不要离开摄像头范围');
		// 			}
		// 		}
		// 	}

		// 	this.examRegist = arr;
		// 	this.dialogVisible = true;
		// },
		// 考试倒计时
		// getTimer(list) {
		// 	list.forEach((item, index) => {
		// 		let startTime = item.exam.exam_start_time;
		// 		let now = new Date().getTime();
		// 		let end = new Date(startTime).getTime();

		// 		if (item.exam_status == 3 && now < end) {
		// 			let leftTime = end - now;
		// 			this.$set(this.getEndTime, index, leftTime);

		// 			this.timer[index] = setInterval(() => {
		// 				leftTime -= 1000;
		// 				if (leftTime >= 0) {
		// 					this.$set(this.getEndTime, index, leftTime);
		// 				} else {
		// 					clearInterval(this.timer[index]);
		// 					this.$set(this.timer, index, null);
		// 				}
		// 			}, 1000);
		// 		}
		// 	});
		// },
		// 重新报名,查看成绩
		// examEnd(item) {
		// 	if (item.exam_status == 2) {
		// 		resetSign({
		// 			record_id: item.id
		// 		}).then(res => {
		// 			if (res.code == 200) {
		// 				this.$router.push('/examCenter');
		// 			}
		// 		});
		// 	} else if (item.exam_status == 6) {
		// 		this.$router.push('/myGradesData');
		// 	}
		// },
	}
};
</script>

<style lang="scss" scoped>
.uni-exam-wrap {
	min-height: $contentH;
	padding: $sideMargin;
	padding-bottom: 0;
}
.uni-exam-pay {
	min-height: inherit;
	background: #fff;

	.divider {
		width: 100%;
		height: 1px;
		background-color: #e9edf7;
	}
	.elTable {
		width: 100%;
		overflow: hidden;
	}
	.continer {
		height: 100%;
		//overflow: hidden;
		padding: 0 20px 20px;
	}

	.filter-box {
		.tit {
			font-size: 16px;
			font-weight: 600;
			margin-right: 20px;
		}

		.btn-box {
			padding: 0 20px;
			height: 30px;
		}

		.filter-list {
			.item {
				display: flex;
				align-items: center;
				padding: 0 20px;
				margin-bottom: 20px;

				&:last-child {
					border: none;
				}
			}
		}

		.select-btn {
			width: 75px;
			height: 25px;
			padding: 0;
		}
	}

	.opera-btn {
		width: 75px;
		height: 25px;
		padding: 0;
		font-size: 12px;
	}

	.link {
		color: $primary;
		cursor: pointer;
	}

	.typeColor1 {
		color: #999999;
	}

	.typeColor2 {
		@include fontColor('primary');
	}
	.dialogContent {
		padding: 0 60px;
		.dialogContent-title {
			position: relative;
			height: 30px;
			h3 {
				font-weight: 400;
				font-size: 20px;
				color: #343434;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				z-index: 10;
			}
			div {
				height: 13px;
				width: 100px;
				background-color: #b2c1ff;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				top: 80%;
			}
		}
		.dialogContent-content {
			margin-top: 20px;
			div {
				padding: 5px 0;
				display: flex;
				span {
					margin-right: 5px;
				}
			}
		}
	}
	/deep/ .el-dialog__footer {
		text-align: center;
	}
	.address {
		color: blue;
		cursor: pointer;
		text-decoration: underline;
	}
}
</style>
